import { render, staticRenderFns } from "./NextModalFrame.vue?vue&type=template&id=e71878c6&scoped=true&"
import script from "./NextModalFrame.vue?vue&type=script&lang=js&"
export * from "./NextModalFrame.vue?vue&type=script&lang=js&"
import style0 from "./NextModalFrame.vue?vue&type=style&index=0&id=e71878c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71878c6",
  null
  
)

export default component.exports